import { Calendar } from 'lucide-react';

interface ProfitabilityDateRangePickerProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
  onReset?: () => void;
  resetLabel?: string;
  compact?: boolean;
  className?: string;
}

/**
 * Shared date-range controls for truth-layer profitability views.
 */
export default function ProfitabilityDateRangePicker({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onReset,
  resetLabel = 'Last 7 days',
  compact = false,
  className = '',
}: ProfitabilityDateRangePickerProps) {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <Calendar className={`${compact ? 'w-3.5 h-3.5' : 'w-4 h-4'} text-muted-foreground shrink-0`} />
      <input
        type="date"
        value={startDate}
        onChange={(e) => onStartDateChange(e.target.value)}
        aria-label="Report start date"
        className={`bg-background border border-border rounded text-foreground focus:ring-success focus:border-success ${
          compact ? 'px-2 py-1 text-xs' : 'px-2 py-1.5 text-xs'
        }`}
      />
      <span className="text-muted-foreground text-xs">to</span>
      <input
        type="date"
        value={endDate}
        onChange={(e) => onEndDateChange(e.target.value)}
        aria-label="Report end date"
        className={`bg-background border border-border rounded text-foreground focus:ring-success focus:border-success ${
          compact ? 'px-2 py-1 text-xs' : 'px-2 py-1.5 text-xs'
        }`}
      />
      {onReset ? (
        <button
          type="button"
          onClick={onReset}
          className="text-xs text-muted-foreground hover:text-foreground underline-offset-2 hover:underline"
        >
          {resetLabel}
        </button>
      ) : null}
    </div>
  );
}
